import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
  },
  summaryHeading: {
    color: STYLE.COLOR.TEXT1,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    marginTop: 24,
    marginBottom: 12,
  },
  summaryList: {
    color: STYLE.COLOR.TEXT1,
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    paddingLeft: 20,
    margin: 0,
    '& li': {
      marginBottom: 0,
    },
  },
  canvasWrapper: {
    position: 'relative',
    backgroundColor: STYLE.COLOR.INPUT_BACKGROUND,
    border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}`,
    borderRadius: '8px',
    marginTop: 28,
    height: 334,
    overflow: 'hidden',
  },
  signPad: {
    width: '100%',
    height: '334px',
  },
  placeholder: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: STYLE.COLOR.TEXT3,
    fontSize: '14px',
    lineHeight: '20px',
    fontStyle: 'italic',
    pointerEvents: 'none',
    userSelect: 'none',
  },
  clearContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 8,
  },
  clearButton: {
    minWidth: 'unset !important',
  },
  disclaimer: {
    color: STYLE.COLOR.TEXT2,
    fontSize: '16px',
    lineHeight: '24px',
  },
}));
